import app from "@/main";
import {durdurucuHataMi, TebligatTuruSatiri, uyapHataMesaji} from "../utils/tebligatTalepUtils";

/** 200 ile gelen ama liste olmayan cevap (ör. {type: "error"}) alınamamış liste sayılır. */
function listeMi(cevap: unknown): TebligatTuruSatiri[] {
    if (!Array.isArray(cevap))
        throw new Error("UYAP tebligat türü listesi beklenen biçimde gelmedi.");
    return cevap;
}

/**
 * Tebligat türü listesini (ad ve ücret) gönderim anında bu avukatın UYAP'ından alır (DEV-3519).
 *
 * Önce önbellek atlanarak (fresh) istenir. Bu istek geçici bir hatayla alınamazsa son 1 gün
 * içinde aynı avukat için önbelleğe yazılmış liste kullanılır. O liste de MDB'deki sabit
 * tablodan daha doğrudur. İkisi de yoksa ücret doğrulanamadığı için evrak gönderilmez.
 * Durdurma, devre kesici ve kimlik hatalarında geri dönüş yapılmaz.
 */
export async function guncelTebligatTurleriniGetir(): Promise<TebligatTuruSatiri[]> {
    try {
        return listeMi(await app.$uyap.PortalAvukatTalepTebligatTuruList().fresh().run({}));
    } catch (e) {
        if (durdurucuHataMi(e))
            throw e;
        console.warn("UYAP tebligat türü listesi taze alınamadı, önbellekteki liste deneniyor:", uyapHataMesaji(e));
        try {
            return listeMi(await app.$uyap.PortalAvukatTalepTebligatTuruList().run({}));
        } catch (e2) {
            if (durdurucuHataMi(e2))
                throw e2;
            throw new Error("UYAP'tan tebligat türü ve ücret listesi alınamadı; ücret doğrulanamadığı için evrak gönderilmedi. (" +
                uyapHataMesaji(e2).trim() + ")");
        }
    }
}
